const wowApp = require('angular').module('wowApp.shop');

wowApp.service('GlobalHeaderAnalyticsService', ['AtmService', require('./global-header-analytics-service')]);

wowApp.service('GlobalHeaderPanelService', ['$rootScope', '$timeout', require('./global-header-panel-service')]);

wowApp.directive('wowGlobalHeader', [
    'ShopperService',
    '$document',
    'ShopPageStateService',
    'BreakpointsService',
    'LoginService',
    'GlobalHeaderAnalyticsService',
    'GlobalHeaderPanelService',
    '$state',
    'TrolleyService',
    'SettingsService',
    '$timeout',
    'CategoriesService',
    'FeatureService',
    '$rootScope',
    'AtmService',
    'RRPubSub',
    'CatalogService',
    'BwsNotificationService',
    '$http',
    '$window',
    require('./global-header-directive')]);

wowApp.directive('wowGlobalScroll', ['$window', '$timeout', 'ShopPageStateService', require('./global-scroller')]);

wowApp.directive('wowGlobalHeaderSkipLinks', ['ShopperService', 'ShopPageStateService', 'MoveFocus', '$timeout', require('./global-header-skip-links-directive')]);

wowApp.directive('wowHamburgerMenu', ['ShopperService', 'CategoriesService', 'LoginService', 'GlobalHeaderPanelService', 'BreakpointsService', 'CatalogService', require('./hamburger-directive')]);

wowApp.directive('wowMobileNavMenu', ['ShopPageStateService', 'panelOverride', 'LoginService', 'ShopperService', 'GlobalHeaderPanelService', 'BreakpointsService', '$timeout', '$state', 'CatalogService', 'SettingsService', require('./mobile-nav-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/index.js
 **/